export default __webpack_public_path__ + "static/media/Group8411.6e0b482e.svg";